import React, { useState, useRef, useContext, useEffect } from 'react';
import {
    Box, Typography, TextField, Button, Select, MenuItem,
    InputLabel, FormControl, Paper, Stack, styled
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { GoogleMap, useJsApiLoader, LoadScript, Marker, Autocomplete } from '@react-google-maps/api';
import SearchBar from './FormsSearchBar';
import FormsBottomNavbar from './FormsBottomNavbar';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { IconButton, InputAdornment } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { AuthContext } from './../../AuthContext/AuthContext';
import { BASE_URL } from './../../Api/ApiUrls';
import ListSubheader from '@mui/material/ListSubheader';
import { checkPropertyUploadLimit_M } from "./checkPropertyUploadLimit_M";
import SubscriptionModal from "./SubscriptionModal";
import {GOOGLEMAPS_API_KEY} from './../../Api/ApiUrls';
import GuestLoginModal from '../../GuestLoginModal';
import { CircularProgress } from '@mui/material';
import SuccessAlert from '../../../Components/Users/Alertpage/SuccessAlert/SuccessAlert';
import FailureAlert from '../../../Components/Users/Alertpage/FailureAlert/FailureAlert';
import FullScreenLoader from '../../FullScreenLoader';

const GOOGLE_MAPS_API_KEY = GOOGLEMAPS_API_KEY; // Replace with your actual key

const containerStyle = {
    width: '100%',
    height: '300px',
};

const centerDefault = {
    lat: 18.387449,
    lng: 78.803236,
};

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)', 
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const RedButton = styled(Button)({
    backgroundColor: 'red',
    color: 'white',
    '&:hover': { backgroundColor: '#cc0000' },
});
const GreenButton = styled(Button)({
    backgroundColor: 'green',
    color: 'white',
    '&:hover': { backgroundColor: '#008000' },
});

const fieldMap = {
    '1BHK': ['Property Name', 'Facing', 'Lease Amount', 'No.of Cars Parking', 'Approx Area',],
    '2BHK': ['Property Name', 'Facing', 'Lease Amount', 'No.of Cars Parking', 'Approx Area'],
    '3BHK': ['Property Name', 'Facing', 'Lease Amount', 'No.of Cars Parking', 'Approx Area'],
    '4+BHK': ['Property Name', 'Facing', 'Lease Amount', 'No.of Cars Parking', 'Approx Area'],
    'Plot': ['Property Name', 'Facing', 'Lease Amount', 'Approx Area'],
    'Land': ['Property Name', 'Facing', 'Lease Amount', 'Acres'],
    'Duplex house': ['Property Name', 'Facing', 'Lease Amount', 'No.of Cars Parking', 'Approx Area'],
    'Commercial land': ['Property Name', 'Facing', 'Lease Amount', 'Approx Area'],
    'Commercial building/space': ['Property Name', 'Facing', 'Lease Amount', 'No.of Cars Parking', 'Approx Area', 'No.of Floors'],
    'Villa': ['Property Name', 'Facing', 'Lease Amount', 'No.of Cars Parking', 'Approx Area'],
    'Pg-school-office': ['Property Name', 'Facing', 'Lease Amount', 'No.of Cars Parking', 'Approx Area', 'No.of Floors', 'Rooms Count'],
    'Shopping mall/shop': ['Property Name', 'Facing', 'Lease Amount', 'No.of Cars Parking', 'Approx Area', 'No.of Floors'],
};
const facingOptions = ['East', 'West', 'North', 'South', 'North-East', 'North-West', 'South-East', 'South-West'];

const LeaseForm = () => { 

    const [workPhotos, setWorkPhotos] = useState([]);
          const { userId, isGuest } = useContext(AuthContext);
       const [showGuestModal, setShowGuestModal] = useState(false);
    const [apiHitCount, setApiHitCount] = useState(0);
    const [usingCurrentLocation, setUsingCurrentLocation] = useState(false);
    const [postedBy, setPostedBy] = useState('');
    const [loading, setLoading] = useState(false);
const [locationConfirmed, setLocationConfirmed] = useState(false);

    const [uploadStatus, setUploadStatus] = useState(null);
    const [showStatusModal, setShowStatusModal] = useState(false);
const [showSuccess, setShowSuccess] = useState(false);
const [showFailure, setShowFailure] = useState(false);
const [alertMessage, setAlertMessage] = useState("");
    const [postedByOptions, setPostedByOptions] = useState([]);
const [uploadLimits, setUploadLimits] = useState(null);
const mapRef = useRef(null); 
const [subscriptionModal, setSubscriptionModal] = useState({
  open: false,
  type: null, // NO_SUBSCRIPTION | LIMIT_EXCEEDED
});

  useEffect(() => {
  if (isGuest) {
    setShowGuestModal(true);
  }
}, [isGuest]);


const isDisabled =
  isGuest || (uploadStatus && !uploadStatus.canUpload);
        
      useEffect(() => {
  const loadPermissions = async () => {
    const result = await checkPropertyUploadLimit_M(userId);

    if (!result.allowed) {
      setSubscriptionModal({
        open: true,
        type:
          result.reason === "NO_SUBSCRIPTION"
            ? "NO_SUBSCRIPTION"
            : "LIMIT_EXCEEDED",
      });
      return;
    }

    setUploadLimits(result.availability);

    const options = [];

    if (result.availability.Agent?.allowed) options.push("Agent");
    if (result.availability.Owner?.allowed) options.push("Owner");
    if (result.availability.Builder?.allowed) options.push("Builder");

    if (options.length === 0) {
      setSubscriptionModal({
        open: true,
        type: "LIMIT_EXCEEDED",
      });
      return;
    }

    setPostedByOptions(options);
  };

  if (userId) loadPermissions();
}, [userId]);


    // Function to generate number options
    const generateNumberOptions = (max = 50) => {
        const options = [];
        for (let i = 0; i <= max; i++) {
            options.push(i);
        }
        return options;
    };


   const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "posted_by") {
        setPostedBy(value);  // For posted_by field
        setFormData((prevData) => ({
            ...prevData,
            posted_by: value,  // Update formData for posted_by
        }));
    } else if (name === "description") {
        // Handle description field
        setFormData((prevData) => ({
            ...prevData,
            description: value,  // Update formData for description
        }));
        setFormValues((prev) => ({
            ...prev,
            description: value,  // Update formValues for real-time change
        }));
    } else {
        // Generic handling for other fields
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setFormValues((prev) => ({
            ...prev,
            [name]: value,
        }));
    }
};



    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
        libraries: ['places'],
    });
    const [location, setLocation] = useState(centerDefault);
    const [address, setAddress] = useState('');
    const [formValues, setFormValues] = useState({});
    const [selectedCategory, setSelectedCategory] = useState('');
    const autocompleteRef = useRef(null);
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);

    const [markerIcon, setMarkerIcon] = useState(null);

    useEffect(() => {
        if (isLoaded && window.google) {
            setMarkerIcon({
                url: "data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22%23ff0000%22%20d%3D%22M12%202C8.13%202%205%205.13%205%209c0%205.25%207%2013%207%2013s7-7.75%207-13c0-3.87-3.13-7-7-7zm0%209.5c-1.38%200-2.5-1.12-2.5-2.5s1.12-2.5%202.5-2.5%202.5%201.12%202.5%202.5-1.12%202.5-2.5%202.5z%22%2F%3E%3C%2Fsvg%3E",
                scaledSize: new window.google.maps.Size(40, 40),
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(20, 40)
            });
        }
    }, [isLoaded]);


    const incrementApiHit = () => {
        setApiHitCount(prev => prev + 1);
        console.log(`Google Maps API hits: ${apiHitCount + 1}`);
    };

    const getCurrentLocation = () => {
        if (navigator.geolocation) {
            setUsingCurrentLocation(true);
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    setLocation(pos);

                    try {
                        const response = await fetch(
                            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${pos.lat},${pos.lng}&key=${GOOGLE_MAPS_API_KEY}`
                        );
                        const data = await response.json();

                        if (data.status == 'OK' && data.results.length > 0) {
                            const address = data.results[0].formatted_address;
                            setAddress(address);
                        } else {
                            console.warn('No address found, fallback to coordinates.');
                            setAddress(`Lat: ${pos.lat.toFixed(6)}, Lng: ${pos.lng.toFixed(6)}`);
                        }
                    } catch (error) {
                        console.error('Google Maps API error:', error);
                        setAddress(`Lat: ${pos.lat.toFixed(6)}, Lng: ${pos.lng.toFixed(6)}`);
                    }
                },
                (error) => {
                    console.error("Error getting current location:", error);
                    alert("Error getting current location. Please enable location services.");
                }
            );
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    };

      const handleWorkPhotosChange = (e) => {
  if (e.target.files) {
    const files = Array.from(e.target.files);

    if (files.length > 4) {
      alert("❌ You can upload maximum 4 images only");
      return;
    }

    setWorkPhotos(files);
  }
};

    const handleMapClick = async (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        setLocation({ lat, lng });
        setUsingCurrentLocation(false);
        incrementApiHit(); // Clicking on map uses Google Maps API

        if (window.google && window.google.maps) {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                if (status == 'OK' && results[0]) {
                    setAddress(results[0].formatted_address);
                } else {
                    setAddress(`Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`);
                }
            });
        }
    };

    useEffect(() => {
        axios.get(`${BASE_URL}/property-category/`)
            .then(response => {
                const rentCategories = response.data.filter(
                    cat => cat.category_type.toLowerCase() == 'rent/lease'
                ); 

                const customOrder = [
                    "1BHK", "2BHK", "3BHK", "4+BHK",
                    "Plot", "Land", "Duplex house", "Commercial land",
                    "Commercial building/space", "Villa",
                    "Pg-school-office", "Shopping mall/shop"
                ];

                // Sort rentCategories according to customOrder
                const sortedCategories = rentCategories.sort((a, b) => {
                    return customOrder.indexOf(a.category) - customOrder.indexOf(b.category);
                });

                setCategories(sortedCategories);
            })
            .catch(error => {
                console.error("Error fetching categories:", error);
            });
    }, []);


    const groupedCategories = categories.reduce((acc, curr) => {
        const type = curr.category_type;
        if (!acc[type]) acc[type] = [];
        acc[type].push(curr);
        return acc;
    }, {});



    const [formData, setFormData] = useState({
        user_id: userId, // This should probably come from user auth
        category_id: '', // This should be mapped from your category selection
        // type: 'lease', // or 'sell' based on your form
        facing: '',
        mobile_no: '',
        roadwidth: '',
        site_area: '',
        buildup_area: '',
        posted_by: '',
        mobile_no: '',
        price: '',
        location: '',
        lat: '',
        long: '',
        nearby: '',
        no_of_flores: '',
        _1bhk_count: '',
        bedrooms_count: '',
        balcony: '',
        gated_security: '',
        parking: '',
        advance_payment: '',
        description: '',
         max_acres: '',
         units: 'sq.ft', 
    });

    useEffect(() => {
        const fetchMobileNo = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/users/`);
                const users = response.data;

                console.log('All users from API:', users);
                console.log('Current userId:', userId);

                const matchedUser = users.find(user => user.user_id == userId);

                if (matchedUser) {
                    setFormData((prevData) => ({
                        ...prevData,
                        mobile_no: matchedUser.mobile_no,
                    }));
                    console.log('Fetched and set mobile_no:', matchedUser.mobile_no);
                } else {
                    console.warn(`User with ID ${userId} not found`);
                }
            } catch (error) {
                console.error('Error fetching mobile_no:', error);
            }
        };

        if (userId) {
            fetchMobileNo();
        }
    }, [userId]);

    const onPlaceChanged = () => {
        if (autocompleteRef.current) {
            const place = autocompleteRef.current.getPlace();
            if (place && place.geometry) {
                incrementApiHit(); // This uses Google Maps API
                setUsingCurrentLocation(false);
                const newLoc = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                };
                setLocation(newLoc);
                setAddress(place.formatted_address);
            }
        }
    };

    const geocodeAddress = async () => {
        if (!address) return;

        if (usingCurrentLocation) {
            // Don't use API if we're using current location
            return;
        }
        if (window.google && window.google.maps) {
            incrementApiHit();
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address }, (results, status) => {
                if (status == 'OK' && results[0]) {
                    const location = results[0].geometry.location;
                    setLocation({
                        lat: location.lat(),
                        lng: location.lng(),
                    });
                    setAddress(results[0].formatted_address);
                } else {
                  //  alert('Address could not be located. Please check input.');
                }
            });
        }
    };

    const labelKeyMap = {
        'Facing': 'facing',
        'Lease Amount': 'price',
        'No.of Cars Parking': 'parking',
        'Approx Area': 'site_area',
        'Acres': 'site_area',
        'No.of Floors': 'no_of_flores',
        'Rooms Count': 'rooms_count',
        'Property Name': 'property_name'
        // Add others as needed
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    const handleSearchClick = () => {
        console.log('Search icon clicked');
    };

    const handleFilterClick = () => {
        console.log('Filter icon clicked');
    };
    const isNumericField = (label) => {
        const numericFields = [
            'Lease Amount',
            'Approx Area',
            'Acres',
            // 'Road Width',
            // 'Buildup Area',
            // 'Length',
            // 'Width',
            // Add other numeric fields
        ];
        return numericFields.includes(label);
    };

    const isValidNumber = (value) => {
        return value === '' || /^[0-9]*\.?[0-9]*$/.test(value);
    };

    const handleFieldChange = (label, value) => {
        const key = labelKeyMap[label] || label;

        if (isNumericField(label) && !isValidNumber(value)) {
            return; // Don't update state if invalid number
        }

        setFormValues(prev => ({ ...prev, [label]: value }));
        setFormData(prev => ({ ...prev, [key]: value }));
    };

  const handleSubmit = async (e) => {
  e.preventDefault();
  console.log('Form submission started.');
   if (workPhotos.length > 4) {
  alert("❌ You can upload maximum 4 images only");
  return;
}


  if (!postedBy) {
    alert("Please select Posted By");
    return;
  }

  if (!uploadLimits) {
    setSubscriptionModal({
      open: true,
      type: "NO_SUBSCRIPTION",
    });
    return;
  }

  const roleKey =
    postedBy === "Agent"
      ? "Agent"
      : postedBy === "Builder"
      ? "Builder"
      : "Owner";

  if (!uploadLimits[roleKey]?.allowed) {
    setSubscriptionModal({
      open: true,
      type: "LIMIT_EXCEEDED",
    });
    return;
  }

  // ✅ START LOADING AFTER ALL VALIDATIONS
  setLoading(true);

  try {

    let site_area = parseFloat(formData.site_area) || 0;

const updatedFormData = { 
  ...formData,
  lat: location.lat,
  long: location.lng,
  location: address,
  site_area: site_area.toString(),
  type: "lease",
};
    console.log('Updated formData with location:', updatedFormData);

    const formDataToSend = new FormData();

    Object.entries(updatedFormData).forEach(([key, value]) => {
      formDataToSend.append(key, value);
    });

    workPhotos.forEach((file,index) => {
      formDataToSend.append("new_property_images", file);
            console.log(`Photo ${index + 1} appended:`, file.name);

    });
    console.log('Sending formData to API...');


    const response = await axios.post(
      `${BASE_URL}/property/`,
      formDataToSend,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
        console.log('API response:', response);


    if (response.status === 201 || response.status === 200) {
      setAlertMessage("Property submitted successfully!");
      setShowSuccess(true);
      // ✅ REMOVED: setTimeout that auto-navigates
    } else {
      setAlertMessage("Something went wrong. Try again.");
      setShowFailure(true);
    }

  } catch (error) {
    if (error.response) {
      setAlertMessage(
        error.response.data.message || "Something went wrong"
      );
    } else {
      setAlertMessage("An error occurred while submitting.");
    }

    setShowFailure(true);

  } finally {
    setLoading(false);
  }
};


    if (!isLoaded) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <Typography>Loading Google Maps...</Typography>
        </Box>;
    }

    return (
        <>
               <Box
                      sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        zIndex: 1200,
                        backgroundColor: "#fff",
                        boxShadow: 1,
                      }}
                    >
            <SearchBar
                onBackClick={handleBackClick}
                onSearchClick={handleSearchClick}
                onFilterClick={handleFilterClick}
            />
            </Box>
         
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '100vh',
                 pt: { xs: '60px', sm: '100px' },  
                        backgroundColor: 'rgb(239, 231, 221)',
                    }}
                >
                    <Box
                        sx={{
                            flexGrow: 1,
                            p: { xs: 2, sm: 3 },
                            pb: 10,
                            display: 'flex',
                            justifyContent: 'center', // center horizontally
                        }}
                    >

                        <Paper
                            elevation={2}
                            sx={{
                                p: { xs: 2, sm: 3 },
                                mb: 3,
                                width: '100%',
                                boxSizing: 'border-box',
                            }}
                            component="form"
                            onSubmit={handleSubmit}
                        >
                            <Typography
                                variant="h5"
                                gutterBottom
                                sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center' }}
                            >
                                Lease Propert Form
                            </Typography>
                            <FormControl fullWidth sx={{ mb: 3 }}>
                                <InputLabel id="category-label">Select Property Type</InputLabel>
                                <Select
                                    labelId="category-label"
                                    value={selectedCategory}
                                    required
                                    onChange={(e) => {
                                        const selected = categories.find(cat => cat.category == e.target.value);
                                        setSelectedCategory(selected.category); // show category name in dropdown
                                        setFormData(prev => ({
                                            ...prev,
                                            category_id: selected.category_id,
                                            type: selected.category_type,
                                        }));
                                    }}
                                    label="Select Category"
                                >
                                    {Object.entries(groupedCategories).map(([type, items]) => [
                                        // Optional: group headers
                                        // <ListSubheader key={type}>{type.toUpperCase()}</ListSubheader>,
                                        ...items.map(cat => (
                                            <MenuItem key={cat.category_id} value={cat.category}>
                                                {cat.category}
                                            </MenuItem>
                                        ))
                                    ])}
                                </Select>
                            </FormControl>


                                                 {selectedCategory &&
                            fieldMap[selectedCategory]?.map((label) => {
                          
                              // ✅ Facing dropdown
                              if (label === 'Facing') {
                                return (
                                  <FormControl fullWidth key={label} sx={{ mb: 2 }}>
                                    <InputLabel>{label}</InputLabel>
                                    <Select
                                      value={formValues[label] || ''}
                                      label={label}
                                      onChange={(e) => handleFieldChange(label, e.target.value)}
                                      required
                                    >
                                      {facingOptions.map(option => (
                                        <MenuItem key={option} value={option}>{option}</MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                );
                              }
                          
                              // ✅ Number dropdowns
                              if (['No.of Cars Parking', 'No.of Floors', 'Rooms Count'].includes(label)) {
                                return (
                                  <FormControl fullWidth key={label} sx={{ mb: 2 }}>
                                    <InputLabel>{label}</InputLabel>
                                    <Select
                                      value={formValues[label] || ''}
                                      label={label}
                                      onChange={(e) => handleFieldChange(label, e.target.value)}
                                    >
                                      {generateNumberOptions().map(num => (
                                        <MenuItem key={num} value={num}>{num}</MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                );
                              }
                          
                       // ✅ AREA FIELD (UPDATED)
if (label === 'Approx Area') {
  return (
    <Box key={label} sx={{ mb: 2 }}>
      <Stack direction="row" spacing={2}>
        <TextField
          fullWidth
          label={
            ['1BHK', '2BHK', '3BHK', '4+BHK'].includes(selectedCategory)
              ? 'Floor Area'
              : 'Approx Area'
          }
          value={formValues[label] || ''}
          onChange={(e) => handleFieldChange(label, e.target.value)}
          type="number"
        />

        <TextField
          select
          label="Units"
          sx={{ minWidth: 120 }}
          value={formData.units || 'sq.ft'}
          onChange={(e) =>
            setFormData(prev => ({ ...prev, units: e.target.value }))
          }
        >
          {['sq.ft', 'sq.m', 'sq.yd'].map(unit => (
            <MenuItem key={unit} value={unit}>{unit}</MenuItem>
          ))}
        </TextField>
      </Stack>
    </Box>
  );
}
                          
                              // ✅ ACRES FIELD (UPDATED)
                              if (label === 'Acres') {
                                return (
                                  <Box key={label} sx={{ mb: 2 }}>
                                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                      Land Area
                                    </Typography>
                          
                                    <Stack direction="row" spacing={2}>
                                      <TextField
                                        fullWidth
                                        label="Acres"
                                        value={formValues[label] || ''}
                                        onChange={(e) => handleFieldChange(label, e.target.value)}
                                        type="number"
                                      />
                          
                                      <TextField
                                        select
                                        label="Units"
                                        sx={{ minWidth: 120 }}
                                        value={formData.units || 'acre'}
                                        onChange={(e) =>
                                          setFormData(prev => ({ ...prev, units: e.target.value }))
                                        }
                                      >
                                        {['acre', 'gunta', 'sq.ft', 'sq.m'].map(unit => (
                                          <MenuItem key={unit} value={unit}>{unit}</MenuItem>
                                        ))}
                                      </TextField>
                                    </Stack>
                                  </Box>
                                );
                              }
                          
                              // ✅ DEFAULT FIELD
                              return (
                                <TextField
                                  key={label}
                                  fullWidth
                                  label={label}
                                  variant="outlined"
                                  sx={{ mb: 2 }}
                                  value={formValues[label] || ''}
                                  onChange={(e) => handleFieldChange(label, e.target.value)}
                                  required
                                  type={isNumericField(label) ? 'number' : 'text'}
                                />
                              );
                            })
                          }

                            {/* Location Section */}
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                                    Location
                                </Typography>

                                <Autocomplete
                                    onLoad={(ref) => (autocompleteRef.current = ref)}
                                    onPlaceChanged={onPlaceChanged}
                                >
                                    <TextField
                                        fullWidth
                                        label="Search Location"
                                        variant="outlined"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        onBlur={geocodeAddress}
                                        required
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={getCurrentLocation} edge="end">
                                                        <MyLocationIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Autocomplete>

                                {/* <Typography variant="caption" sx={{ alignSelf: 'center', mt: 1, display: 'block' }}>
        {usingCurrentLocation ? "Using browser geolocation" : "Using Google Maps API"}
    </Typography> */}
                            </Box>

                            {/* <GoogleMap
                                mapContainerStyle={containerStyle}
                                center={location}
                                zoom={15}
                                onClick={handleMapClick}
                            >
                                {markerIcon && (
                                    <Marker
                                        position={location}
                                        icon={markerIcon}
                                    />
                                )}


                            </GoogleMap> */}

                            

                            {/* <div style={{ ...containerStyle, position: 'relative' }}>
  <GoogleMap
    mapContainerStyle={{ width: '100%', height: '100%' }}
    center={location}
    zoom={15}
    onClick={handleMapClick}
    onDragEnd={(map) => {
      if (map) {
        const center = map.getCenter();
        const lat = center.lat();
        const lng = center.lng();
        setLocation({ lat, lng });

        if (window.google && window.google.maps) {
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            if (status === 'OK' && results[0]) {
              setAddress(results[0].formatted_address);
            } else {
              setAddress(`Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`);
            }
          });
        }
      }
    }}
  />

  
  <div
    style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -100%)',
      pointerEvents: 'none',
      zIndex: 10,
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 24 24"
    >
      <path
        fill="#ff0000"
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      />
    </svg>
  </div>
</div> */}
<div style={{ ...containerStyle, position: 'relative' }}>
  <GoogleMap
    mapContainerStyle={{ width: '100%', height: '100%' }}
    center={location}
    zoom={15}
    options={{ gestureHandling: 'greedy' }}
    onLoad={(map) => {
      mapRef.current = map;
    }}
    onDragStart={() => {
      // User started moving the map → unconfirm location, turn button red
      setLocationConfirmed(false);
    }}
  />

  {/* Fixed pin at center */}
  <div
    style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -100%)',
      pointerEvents: 'none',
      zIndex: 10,
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
      <path
        fill="#ff0000"
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      />
    </svg>
  </div>

  {/* Confirm location button — red = unconfirmed, green = confirmed */}
  <button
    type="button"
    onClick={() => {
      if (window.google && window.google.maps && mapRef.current) {
        const center = mapRef.current.getCenter();
        const lat = center.lat();
        const lng = center.lng();
        setLocation({ lat, lng });

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode(
          { location: { lat, lng } },
          (results, status) => {
            if (status === 'OK' && results[0]) {
              const selectedAddress = results[0].formatted_address;
              setAddress(selectedAddress);
              setFormData(prev => ({
                ...prev,
                location: selectedAddress,
                lat: lat.toString(),
                long: lng.toString(),
              }));
            } else {
              const fallback = `Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`;
              setAddress(fallback);
              setFormData(prev => ({
                ...prev,
                location: fallback,
                lat: lat.toString(),
                long: lng.toString(),
              }));
            }
            // ✅ Mark location as confirmed → button turns green
            setLocationConfirmed(true);
          }
        );
      }
    }}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: locationConfirmed ? 'green' : 'red', // 🔴 red → 🟢 green
      border: 'none',
      borderRadius: '50%',
      width: '44px',
      height: '44px',
      cursor: 'pointer',
      boxShadow: '0 2px 8px rgba(0,0,0,0.4)',
      position: 'absolute',
      right: '10px',
      top: '45%',
      transform: 'translateY(-50%)',
      zIndex: 10,
      transition: 'background-color 0.3s ease', // smooth color change
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
      <path fill="white" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
    </svg>
  </button>
</div>


                            {/* Upload Section */}
                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
                                Upload Images
                            </Typography>
                            <Button component="label" variant="outlined" startIcon={<CloudUploadIcon />} fullWidth sx={{ mb: 3 }}>
                                Upload Images
                                <VisuallyHiddenInput
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={handleWorkPhotosChange}
                                    required
                                />
                            </Button>
                            <Typography variant="caption" color="text.secondary">
                                                      Max 4 images allowed
                                                    </Typography>
                            {workPhotos.length > 0 && (
                                <Typography variant="caption" display="block" gutterBottom>
                                    Selected: {workPhotos.length} file(s)
                                </Typography>
                            )}

                          
                                                  <FormControl fullWidth margin="normal">
                            <InputLabel>Posted By</InputLabel>
                            <Select
                              value={postedBy}
                              name="posted_by"
                              onChange={handleChange}
                              required
                            >
                              {postedByOptions.map((role) => (
                                <MenuItem key={role} value={role}>
                                  {role}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>


                            {/* Description */}
                            {/* <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>Description</Typography>
       <TextField
    fullWidth
   
    variant="outlined"
    multiline
    rows={4}
    name="description"  // Make sure name matches the key in the state
    value={formValues.description || ''}  // Bind to formValues for real-time input update
    onChange={handleChange}  // Handle changes with handleChange
    sx={{ mb: 2 }}  // Optional styling for spacing 
/> */}



                         <>
  {/* 🔥 Full Screen Loader */}
  <FullScreenLoader
    open={loading}
    text="Submitting property..."
  />

  <Stack
    direction="row"
    spacing={2}
    justifyContent="center"
    sx={{ mt: 2, mb: 2 }}
  >
    <RedButton
      variant="contained"
      size="large"
      sx={{ px: 4, fontWeight: "bold" }}
      onClick={() => navigate(-1)}
      disabled={loading}
    >
      Cancel
    </RedButton>

    <GreenButton
      variant="contained"
      size="large"
      type="submit"
      disabled={
        loading ||
        isDisabled
      }
      sx={{
        px: 4,
        fontWeight: "bold",
        backgroundColor: (loading || isDisabled) ? "#ccc" : undefined,
        color: (loading || isDisabled) ? "#777" : undefined,
        cursor: (loading || isDisabled) ? "not-allowed" : "pointer",
        "&:hover": {
          backgroundColor: (loading || isDisabled) ? "#ccc" : undefined,
        },
      }}
    >
      {uploadStatus && !uploadStatus.canUpload
        ? "Upload Limit Reached"
        : loading
        ? "Submitting..."
        : isGuest
        ? "Login required to submit"
        : "Submit"}
    </GreenButton>
  </Stack>
</>
                        </Paper>
                    </Box>

                    {/* Bottom Spacer */}
                    <Box sx={{ height: '70px' }} />
                </Box>
            
                        <SubscriptionModal
              open={subscriptionModal.open}
              type={subscriptionModal.type} 
              onClose={() =>
                setSubscriptionModal({ open: false, type: null })
              }
            />

               <GuestLoginModal
              open={showGuestModal}
              onClose={() => {
                setShowGuestModal(false);
              }}
            />
{showSuccess && (
  <SuccessAlert
    message={alertMessage}
    onClose={() => {
      setShowSuccess(false);
      navigate("/dashboard");
    }}
  />
)}

{showFailure && (
  <FailureAlert
    message={alertMessage}
    onClose={() => {
      console.log("Closing failure alert"); // Debug log
      setShowFailure(false);
      setAlertMessage(""); 
     
      navigate("/lease-form");
    }}
  />
)}
            <FormsBottomNavbar />
        </>
    );
};

export default LeaseForm;
